module.exports = __webpack_public_path__ + "img/stop_sale.9193862c.png";